<script setup lang="ts">
import { currentLocale, setLocale } from '@/plugins/i18n';
import { onMounted, ref, watch, inject, computed } from 'vue';
import { QSelect } from 'quasar';
import { VueCookies } from 'vue-cookies';
import { Locales } from '@/store/language.interface';

// CONST
const initialLocales = ref([]);
const locales = ref([]);
const selectedLocale = ref<Locales>(currentLocale());
const cookies = inject<VueCookies>('$cookies');
const currentLocal = computed(() => currentLocale());
const props = defineProps<{
  languageEnabled?: Locales[];
}>();

// LIFECYCLE
onMounted(() => {
  initialLocales.value = props.languageEnabled;
  initialLocales.value.forEach((locale) => locales.value.push(locale));
});

// WATCH
watch(selectedLocale, (newValue) => {
  cookies.set('locale', newValue);
  setLocale(newValue);
});
watch(currentLocal, (newValue) => {
  selectedLocale.value = newValue;
});
</script>

<template>
  <div class="locale-select">
    <q-select label-color="primary" color="primary" borderless v-model="selectedLocale" :options="locales">
      <template v-slot:prepend>
        <q-icon name="o_language" />
      </template>
      <template v-slot:option="scope">
        <q-item v-bind="scope.itemProps">
          <q-item-section>
            <q-item-label>{{ scope.opt.toUpperCase() }}</q-item-label>
          </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<style lang="scss">
.locale-select {
  .q-select {
    text-transform: uppercase;
  }

  .q-field--auto-height .q-field__control {
    min-height: 40px !important;
    height: 40px !important;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
  }

  .q-field__prepend {
    padding-right: 6px;
  }

  .q-field__append {
    padding-left: 6px;
  }
}
</style>
